import { Component, HostListener } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Sidebar } from './Components/sidebar/sidebar';
import { Header } from './Components/header/header';
import { filter } from 'rxjs/operators';
import { LoaderComponent } from './Components/loader/loader.component';
import { environment } from './environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, Sidebar, Header, LoaderComponent],
  templateUrl: './app.html',
  styleUrls: ['./app.css']
})
export class App {
  isLoginPage = false;
  isSidebarOpen = false;

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      const baseUrl = event.urlAfterRedirects.split('?')[0];

      this.isLoginPage = baseUrl === '/login' || baseUrl === '/' || baseUrl === '/signup';
      this.isSidebarOpen = false;
    });
  }

   @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    if (!environment.inspectOn) {
      event.preventDefault();
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (environment.inspectOn) return;

    if (event.key === 'F12') {
      event.preventDefault();
    }

    if ((event.ctrlKey || event.metaKey) && event.shiftKey && (event.key === 'I' || event.key === 'i')) {
      event.preventDefault();
    }

    if ((event.ctrlKey || event.metaKey) && event.shiftKey && (event.key === 'C' || event.key === 'c')) {
      event.preventDefault();
    }

    if ((event.ctrlKey || event.metaKey) && event.shiftKey && (event.key === 'J' || event.key === 'j')) {
      event.preventDefault();
    }

    if ((event.ctrlKey || event.metaKey) && (event.key === 'U' || event.key === 'u')) {
      event.preventDefault();
    }
  }
}